import { schema } from 'normalizr';
import {
  entitiesSelectorList,
  entitiesSelectorItem,
} from '../utils/asyncHelpers';

const schemaEntity = new schema.Entity('productionUnitDocument');

export const getProductionUnitDocuments = entitiesSelectorList(schemaEntity);
export const getProductionUnitDocument = entitiesSelectorItem(schemaEntity);
export default schemaEntity;
